import { useField } from "formik";
import { FormGroup, Form } from "react-bootstrap";

const CustomTextArea = ({
  placeholder,
  label,
  loading,
  text,
  children,
  typeInput,
  className,
  height,
  ...props
}) => {
  const [field, meta] = useField({ ...props });
  return (
    <FormGroup className={className}>
      {label ? <Form.Label>{label}</Form.Label> : null}
      <Form.Control
        as="textarea"
        placeholder={placeholder}
        style={{ height: height ? height : "100px" }}
        isInvalid={meta.error && meta.touched && meta.error}
        disabled={loading ? true : false}
        {...field}
        {...props}
      />
      <Form.Control.Feedback type="invalid">
        {meta.touched && meta.error ? meta.error : null}
      </Form.Control.Feedback>
    </FormGroup>
  );
};

export default CustomTextArea;
